import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';

const ARDUINO_LONG_MAX = 2147483647;
const ARDUINO_LONG_MIN = -2147483648;

class NumberField extends Blockly.FieldNumber {
    override initView() {
        super.initView();
        const t = (this as any).textElement_ as SVGTextElement | undefined;
        t?.classList.add('blocklyNumberFieldText');

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                (this as any).updateSize_?.();
            });
        });
    }

    protected override render_() {
        super.render_();
        const block = this.getSourceBlock() as Blockly.BlockSvg | null;
        if (!block) return;
        const ws = block.workspace as Blockly.WorkspaceSvg;
        if (ws?.isFlyout) {
            requestAnimationFrame(() => {
                (this as any).updateSize_?.();
                block.render();
            });
        }
    }

    override doClassValidation_(newValue?: any): number | null {
        if (newValue === undefined || newValue === null) return null;
        const str = String(newValue).trim();
        if (!/^-?\d+(?:\.\d+)?$/.test(str)) return null;
        const num = Number(str);
        if (num > ARDUINO_LONG_MAX || num < ARDUINO_LONG_MIN) return null;
        return Math.trunc(num);
    }

    protected override showEditor_() {
        super.showEditor_();
        requestAnimationFrame(() => {
            const htmlInput = document.querySelector('.blocklyHtmlInput') as HTMLInputElement | null;
            if (htmlInput) {
                htmlInput.style.fontFamily = 'Cantarell, sans-serif';
                htmlInput.style.fontWeight = '600';
                htmlInput.setAttribute('inputmode', 'numeric');
                htmlInput.maxLength = 11;

                const widgetDiv = htmlInput.closest('.blocklyWidgetDiv') as HTMLElement | null;
                if (widgetDiv) {
                    const current = parseFloat(widgetDiv.style.width || '0');
                    widgetDiv.style.width = `${current + 4}px`;

                    const fieldRect = (this as any).textElement_?.getBoundingClientRect();
                    const divRect = widgetDiv.getBoundingClientRect();
                    if (fieldRect) {
                        const fieldCenterX = fieldRect.left + fieldRect.width / 2;
                        const divCenterX = divRect.left + divRect.width / 2;
                        const currentLeft = parseFloat(widgetDiv.style.left || '0');
                        widgetDiv.style.left = `${currentLeft + (fieldCenterX - divCenterX)}px`;
                    }
                }
            }
        });
    }
}

defineBlock({
    type: 'number',
    colour: '',
    tooltip: '数値',
    movable: true,
    deletable: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    name: 'NUM',
                    instance: () => new NumberField(0, -Infinity, Infinity, 0),
                },
            ],
        },
    ],
});
